module.exports = __webpack_public_path__ + "static/img/icon_Scan@2x.54d28856.png";